import app from './app'
import care from './component/care/index'
import welfare from './component/care/welfare'
import welfareDetail from './component/care/welfareDetail'
import welfarePreorder from './component/care/welfarePreorder'
import welfareSuccess from './component/care/welfareSuccess'
import orderDetail from './component/care/orderDetail'
import orderTrack from './component/care/orderTrack'
import explorer from './component/explorer/index'
import activity from './component/explorer/activity'
// import birthdayBoard from './component/explorer/birthdayBoard'
import aboutme from './component/aboutme/index'
import myactivity from './component/aboutme/activity'
import help from './component/aboutme/help'
import help1 from './component/aboutme/help1'
import help2 from './component/aboutme/help2'
import help3 from './component/aboutme/help3'
import help4 from './component/aboutme/help4'
import help5 from './component/aboutme/help5'
import address from './component/aboutme/address'
import addressAdd from './component/aboutme/addressAdd'
import addressEdit from './component/aboutme/addressEdit'
import cards from './component/aboutme/cards'
import prize from './component/aboutme/prize'
import virtualPrize from './component/aboutme/virtualPrize'
import mywelfare from './component/aboutme/welfare'
//生日场景相关
import birthdayBoard from './component/birthday/board'
import birthdayList from './component/birthday/list'
import birthdayPersonal from './component/birthday/personal'
import birthdayIntroduction from './component/birthday/introduction'
import birthdayAnswer from './component/birthday/answer'
import birthdayWishDetail from './component/birthday/wish'
//个人中心
import PersonalIndex from './component/personal/index'
import ServiceForbidden from './component/common/serviceForbidden'
import Support from './component/support/index'
import ErrPage from './component/error/index'

export default [{
  path: '/',
  name: 'app',
  component: app,
  children: [{
    path: '/',
    name: 'care',
    component: care
  },
  {
    path: '/error',
    name: 'error',
    component: ErrPage
  },
    {
      path: '/care',
      name: 'care',
      component: care
    },
    {
      path: '/welfare/package',
      name: 'welfare',
      component: welfare
    },
    {
      path: '/welfare/detail',
      name: 'welfareDetail',
      component: welfareDetail
    },
    {
      path: '/welfare/preorder',
      name: 'welfarePreorder',
      component: welfarePreorder
    },
    {
      path: '/welfare/order_success',
      name: 'welfareSuccess',
      component: welfareSuccess
    },
    {
      path: '/order/detail',
      name: 'orderDetail',
      component: orderDetail
    },
    {
      path: '/order/track',
      name: 'orderTrack',
      component: orderTrack
    },
    {
      path: '/explorer',
      name: 'explorer',
      component: explorer
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/aboutme',
      name: 'aboutme',
      component: aboutme
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/help/1',
      name: 'help1',
      component: help1
    },
    {
      path: '/help/2',
      name: 'help2',
      component: help2
    },
    {
      path: '/help/3',
      name: 'help3',
      component: help3
    },
    {
      path: '/help/4',
      name: 'help4',
      component: help4
    },
    {
        path: '/help/5',
        name: 'help5',
        component: help5
      },
    {
      path: '/my/activity',
      name: 'myactivity',
      component: myactivity
    },
    {
      path: '/address/',
      name: 'address',
      component: address
    },
    {
      path: '/address/add',
      name: 'addressAdd',
      component: addressAdd
    },
    {
      path: '/address/edit',
      name: 'addressEdit',
      component: addressEdit
    },
    {
      path: '/my/cards', //关怀消息
      name: 'cards',
      component: cards
    },
    {
      path: '/my/prize',
      name: 'prize',
      component: prize
    },
    {
      path: '/my/virtualPrize',
      name: 'virtualPrize',
      component: virtualPrize
    },
    {
      path: '/my/welfare',
      name: 'mywelfare',
      component: mywelfare
    },
    {
      path: '/birthday/board',
      name: 'birthdayBoard',
      component: birthdayBoard
    },
    {
      path: '/birthday/list',
      name: 'birthdayList',
      component: birthdayList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/birthday/personal',
      name: 'birthdayPersonal',
      component: birthdayPersonal
    },
    {
      path: '/birthday/introduction',
      name: 'birthdayIntroduction',
      component: birthdayIntroduction
    },
    {
      path: '/birthday/answer',
      name: 'birthdayAnswer',
      component: birthdayAnswer
    },
    {
      path: '/birthday/wish',
      name: 'birthdayWishDetail',
      component: birthdayWishDetail
    },
    {
      path: '/profile',
      name: 'PersonalIndex',
      component: PersonalIndex
    },
    {
      path: '/serviceForbidden',
      name: 'ServiceForbidden',
      component: ServiceForbidden
    },
    {
      path: '/support',
      name: 'Support',
      component: Support
    }

  ]
}]
